// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.daterangearrow[data-v-e32f5ff2] {\n  margin-top: 36px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.daterangearrow[data-v-e32f5ff2]:hover {\n  background: #ccc;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
